module.exports = __webpack_public_path__ + "img/icon-lock-incompleted.a515f3ab.svg";